import { Injectable }                        from "@angular/core";
import { CONFIGURATION }                     from "../../../../app.constants";
import { Task, Pagination, User, UserContactInfo }            from "../../../../models";
import { Observable }                        from "rxjs/Observable";
import { HttpDataService }                   from "../../../../services/shared";
import { CommonUtility }                     from "../../../../utils/commonUtility";

@Injectable()
export class UserContactInfoService {

    constructor(private httpData: HttpDataService,
        private commonUtility: CommonUtility) { }

    public Update(contactInfo: UserContactInfo): Observable<User> {
        contactInfo.dateOfBirth = this.commonUtility.ConvertLocalDateToUTCDate(contactInfo.dateOfBirth);
        return Observable.create((observer) => {
            this.httpData.post(CONFIGURATION.baseUrls.apiUrl + "account/UpdateContactInfo", JSON.stringify(contactInfo))
                .map(response => <User>response.json().result)
                .subscribe((userData) => {
                    observer.next(userData);
                }, (error) => observer.error(error),
                () => observer.complete());
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/userHome/userDetails/contactInfo/contactInfo.service.ts